import { createSlice } from '@reduxjs/toolkit'
import { getDoctors } from 'redux/thunks/get-doctors'
import { Doctor } from 'types'

export interface DoctorsState {
  isLoading: boolean
  doctors: Doctor[]
}

const initialState: DoctorsState = {
  isLoading: false,
  doctors: []
}

export const doctorsSlice = createSlice({
  name: 'doctors',
  initialState,
  reducers: {
    resetDoctorsState: (state) => {
      state = initialState
      return state
    }
  },
  extraReducers: (builder) =>
    builder
      .addCase(getDoctors.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getDoctors.fulfilled, (state, action) => {
        state.isLoading = false
        state.doctors = action.payload
      })
      .addCase(getDoctors.rejected, (state) => {
        state.isLoading = false
      })
})

export const { resetDoctorsState } = doctorsSlice.actions

export default doctorsSlice.reducer
